import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-cover-flow",
  "use": "icon-si-glyph-cover-flow-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-cover-flow\" id=\"icon-si-glyph-cover-flow\"><title>1192</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 2.000000)\" fill=\"#434343\"><path d=\"M4,2 L4,10 L11.894,10 L12,2 L4,2 Z\" class=\"si-glyph-fill\" /><path d=\"M13,2 L13,10 L13.916,10 L13.916,2 L13,2 Z\" class=\"si-glyph-fill\" /><rect x=\"15\" y=\"0\" width=\"1\" height=\"12\" class=\"si-glyph-fill\" /><rect x=\"2\" y=\"2\" width=\"1\" height=\"8\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"0\" width=\"0.979\" height=\"11.918\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-cover-flow.svg
// module id = I03U
// module chunks = 62